import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { ClockHistory } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

class CHNQueue extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			requestList: this.copyRequestList(),
			archive: {
				BILLINGDATE: null
			},
			searchCount: null,
			renderKey: 0
		};
	}
	
	copyRequestList() {
		// make copy of request list
		var newRequestList = this.copyTable(requestList);
		// if user is not an admin
		if (!this.isAdmin()) {
			// remove admin columns
			newRequestList.columns = this.removeColumnsByAccessor(newRequestList.columns, ['STATUS','REQUESTDATEDISPLAY','POSTPONE']);
		}
		
		return newRequestList;
	}
	
	copyExportColumns() {
		// if user is admin
		if (this.isAdmin()) {
			// return copy of export columns
			return this.copyColumns(exportColumns);
		} else {
			// return copy without admin columns
			return this.removeColumnsByAccessor(exportColumns, ['STATUS','REQUESTDATEDISPLAY']);
		}
	}

	isAdmin() {
		return ('' + this.props.user.uid).startsWith('fas.admin.') ||
			(this.props.user.fas && this.props.user.fas.authLevel === 1);
	}
	
	onSubmitSearch(event) {
		this.mergeState({ 
			requestList: this.copyRequestList(),
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	addRequest() {
		this.props.navigate('/FAS/AddRequest');
	}
	
	canViewRequest(userId) {
		return (this.isAdmin() || (
			('' + this.props.user.uid).startsWith('fas.user.') &&
			+this.props.user.uid.substring(9) === +userId));
	}
	
	editRequest(facilitiesId, requestId) {
		if (facilitiesId === 34) {
			this.props.navigate('/FAS/Microrequests/' + requestId);
		} else if (facilitiesId === 33) {
			this.props.navigate('/FAS/Xrayrequests/' + requestId);
		}
	}
	
	onClickArchive() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/Archive',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				search: this.constructSearch(this.state.search),
				billingdate: this.state.archive.BILLINGDATE
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>{data.Message}</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	onPostponeRequest(requestId) {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/UpdateMicrorequest',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				request: {
					ID: requestId,
					STATUS: 'Postponed'
				}
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>
						Request <Link to={'/FAS/Microrequests/' + requestId}>{requestId}</Link> postponed.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'CHN and CHNS Queue',
			columns: this.copyExportColumns(),
			entity: 'FAS.REQUESTS_VW',
			search: this.state.requestList.query.search,
			order: 'REQUESTDATE'
		});			

		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>CHN and CHNS Queue</div>
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="search" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='FAS_CHNQueue' table={this.state.requestList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='146px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const requestList = {
	query: { entity: 'FAS.REQUESTS_VW', search: { Operator: 'and', Children: [
			{ Attribute: 'STATUS', Operator: 'in', StringList: ['Saved','Submitted','Updated'] },
			{ Attribute: 'SERVICE', Operator: 'in', StringList: ['CHN','CHNS','CHN (F)','CHNS (F)'] },
			{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
		]}, order: 'REQUESTDATE' },
	pageSize: 20,
	columns: [
		{ Header: '', accessor: 'FACILITIESID', show: false },
		{ Header: '', accessor: 'ID', show: false },
		{ Header: '', accessor: 'USERID', show: false },
		{ Header: 'Request No.', accessor: 'IDDISPLAY', width: 100,
			Cell: props => props.parent.canViewRequest(props.row.values.USERID) ?
				<HashLink onClick={() => props.parent.editRequest(34, props.row.values.ID)}>{props.value}</HashLink> : <>{props.value}</> },
		{ Header: 'Request Date', accessor: 'REQUESTDATEDISPLAY', width: 100 },
		{ Header: 'Requester Name', accessor: 'NAME', width: 250 },
		{ Header: 'Facility', accessor: 'CODE', width: 80 },
		{ Header: 'Service', accessor: 'SERVICE', width: 125 },
		{ Header: 'Status', accessor: 'STATUS', width: 100 },
		{ Header: 'Postpone', accessor: 'POSTPONE', width: 75, align: 'center',
			Cell: props => <ClockHistory style={{ cursor: 'pointer' }} onClick={() => props.parent.onPostponeRequest(props.row.values.ID)} /> }
	]
};

const exportColumns = [
	{ Header: 'Request No.', accessor: 'IDDISPLAY', width: 20 },
	{ Header: 'Request Date', accessor: 'REQUESTDATEDISPLAY', width: 20 },
	{ Header: 'Requester Name', accessor: 'NAME', width: 50 },
	{ Header: 'Facility', accessor: 'CODE', width: 16 },
	{ Header: 'Service', accessor: 'SERVICE', width: 25 },
	{ Header: 'Status', accessor: 'STATUS', width: 20 },
];

export default withRouter(CHNQueue);
